<div class="app-pager-chips-container grid-auto-1 app-space-left_1">
  <div class="app-space_none  app-pager-separator">
    <app-exg-dropdown #VCGroupDropDown position="abovecenter" >
      <ng-template #hostTemplate>
        <i class="search-filter-action fa-filter"
           [class.fas]="appSrv.metaInfo.uiFilterAktiv(inputDataTable['uiFilter']).length > 0"
           [class.far]="appSrv.metaInfo.uiFilterAktiv(inputDataTable['uiFilter']).length === 0"
           [class.disabled]="controller.uiFilterAktiv().length <= 3"></i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <form class="md-menu content width-400"
              *ngIf="!(controller.uiFilterAktiv().length <= 3)">
          <div class="layout-1-auto">
            <div class="content app-layout-auto-auto-auto-auto">
              <ng-container *ngIf="controller.uiFilterActivApplied(3, undefined, 1).length !== 0">
                <div class="md-menu-header app-space_025">
                  {{getGlobal('PopupHeaderFilter')}}
                </div>
                <div class="content app-pad_075">
                  <exg-chips [list]="controller.uiFilterActivApplied(3, undefined, 1)"
                             listdisplay="chipUiCaption"
                             (ItemClose)="controller.chipClose_resetFilter($event)">
                  </exg-chips>
                </div>
              </ng-container>
              <ng-container *ngIf="controller.uiFilterActivApplied(3, undefined, 2).length !== 0">
                <div class="md-menu-header  app-space_025">
                  {{getGlobal('PopupHeaderSearch')}}
                </div>
                <div class="content app-pad_075">
                  <exg-chips [list]="controller.uiFilterActivApplied(3, undefined, 2)"
                             listdisplay="chipUiCaption"
                             (ItemClose)="controller.chipClose_resetFilter($event)">
                  </exg-chips>
                </div>
              </ng-container>
            </div>
            <div class="md-menu-footer">
              <button class="md-btn" type="button" (click)="VCFilterControl.VCFilter.ResetFilter()">{{getGlobal('Reset')}}</button>
            </div>
          </div>
        </form>
      </ng-template>
    </app-exg-dropdown>
  </div>
  <div class="spawn-reverse">
    <exg-chips [list]="controller.uiFilterActivApplied(0, 3)" *ngIf="!inputDataTable.isLoading"
               listdisplay="chipUiCaption"
               (ItemClose)="controller.chipClose_resetFilter($event)">
    </exg-chips>
  </div>
</div>
